<template>
	<!-- DCTL-2048 (Nav IA Phase 4): behind project-dashboard this surface becomes
	     the read-only orphaned-papers safety-net list. With the flag OFF it stays
	     the full paper-management table (add/edit/delete), unchanged. -->
	<orphaned-papers v-if="projectDashboardEnabled" />
	<v-row v-else align-content="start" justify="start">
		<v-col cols="12">
			<paper-table />
		</v-col>
	</v-row>
</template>

<script>
import { useProjectDashboardEnabled } from "@/composables/useProjectDashboardEnabled";
import PaperTable from "@/pages/PaperManager/PaperTable";
import OrphanedPapers from "@/pages/PaperManager/OrphanedPapers.vue";

export default {
	name: "PaperManager",

	components: {
		PaperTable,
		OrphanedPapers,
	},

	setup() {
		// DCTL-2113: honor the per-user classic-queue opt-out, not just the raw flag.
		const { enabled: projectDashboardEnabled } = useProjectDashboardEnabled();
		return { projectDashboardEnabled };
	},
};
</script>

<style scoped lang="scss">
.col {
	flex-grow: 0;
}
</style>
